import { Component } from '@angular/core';

@Component({
	selector: 'shell',
	template: require('./shell.template.html')
})
export class ShellComponent {
	constructor() {
		this.year = "" + new Date().getFullYear();

	}

	year;

	toggleSidebar() {
		this.sideBarOpen = !this.sideBarOpen;
	}

	sideBarOpen = true;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shell/shell.component.ts